import { render, staticRenderFns } from "./BranchSetupWizard.vue?vue&type=template&id=2c08191e&scoped=true&"
import script from "./BranchSetupWizard.vue?vue&type=script&lang=js&"
export * from "./BranchSetupWizard.vue?vue&type=script&lang=js&"
import style0 from "./BranchSetupWizard.vue?vue&type=style&index=0&id=2c08191e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c08191e",
  null
  
)

export default component.exports